/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronRight } from 'react-feather';
import { Badges, H6, LI, UL } from '../../AbstractElements'
import { MenuListType, SidebarItemTypes } from '../../Types/Layout.type'
import { RootState } from '../../store/Store';
import { handlePined, setSideBarToggle } from '../../store/reducers/Layout/LayoutReducer';
import { Href } from '../../Utils/Constants';
import SvgIcon from '../../Utils/CommonComponents/CommonSvgIcons';

export default function SidebarSubMenu({ menu, setActiveMenu, activeMenu, level, className }: MenuListType) {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { pinedMenu } = useSelector((state: RootState) => state.layout);
    const location = useLocation();
    const ActiveNavLinkUrl = (path?: string, active?: boolean) => {
        const currentPath = location.pathname.split('?')[0].replace(/\/$/, "");
        const targetPath = path ? path.split('?')[0].replace(/\/$/, "") : "";
        if (currentPath === targetPath) return active ? active : true;
        return "";
    };
    const shouldSetActive = ({ item }: SidebarItemTypes) => {
        var returnValue = false;
        const currentPath = location.pathname.split('?')[0].replace(/\/$/, "");
        const targetPath = item?.path ? item.path.split('?')[0].replace(/\/$/, "") : "";
        if (targetPath === currentPath) returnValue = true;
        if (!returnValue && item?.children) {
            item?.children.every((subItem) => {
                returnValue = shouldSetActive({ item: subItem });
                return !returnValue;
            });
        }
        return returnValue;
    };
    const handleClick = ((item: any) => {
        setActiveMenu((prev: any) => {
            const temp = [...prev];
            temp[level] = item.title !== temp[level] ? item.title : "";
            return temp;
        });

        if (item.type === 'link' && window.innerWidth <= 1200) {
            dispatch(setSideBarToggle(true));
        }
    })
    
    useEffect(() => {
        let activeItemTitle = "";
        menu?.forEach((item: any) => {
            let gotValue = shouldSetActive({ item });
            if (gotValue) {
                activeItemTitle = item.title;
            }
        });

        setActiveMenu((prev: any) => {
            const currentActiveTitle = prev[level];
            
            if (activeItemTitle) {
                if (currentActiveTitle !== activeItemTitle) {
                    let temp = [...prev];
                    temp[level] = activeItemTitle;
                    return temp;
                }
            } else {
                const isOurItemActive = menu?.some((item: any) => item.title === currentActiveTitle);
                if (isOurItemActive) {
                    let temp = [...prev];
                    temp[level] = "";
                    return temp;
                }
            }
            return prev;
        });
    }, [location.pathname, level, setActiveMenu]);

    return (
        <>
            {menu?.map((item, index) => (
                <LI key={index} className={`${level === 0 ? "sidebar-list" : ""} ${pinedMenu.includes(item.title || "") ? "pined" : ""}  
                ${(item.children
                        ? item.children.map((innerItem) => ActiveNavLinkUrl(innerItem.path)).includes(true)
                        : ActiveNavLinkUrl(item.path)) || activeMenu[level] === item.title
                        ? "active"
                        : ""
                    } `}
                >
                    {level === 0 && (<i className="fa-solid fa-thumbtack" onClick={() => dispatch(handlePined(item.title))} />)}
                    <Link
                        className={`${!className && level !== 2 ? "sidebar-link " : item.type === "sub" ? "submenu-title" : ""} 
                        ${(item.children
                                ? item.children.map((innerItem) => ActiveNavLinkUrl(innerItem.path)).includes(true)
                                : ActiveNavLinkUrl(item.path)) || activeMenu[level] === item.title ? "active" : ""
                            }`}
                        to={item.path ? item.path : Href}
                        onClick={() => handleClick(item)}
                    >
                        {item.icon && (
                            <span className="icon-wrapper">
                                <SvgIcon className='stroke-icon' iconId={item.icon} />
                            </span>
                        )}
                        <H6>{t(`${item.title}`)}</H6>
                        {item.badge ? <Badges color='primary'>{item.badgeName}</Badges> : ''}
                        {item.children && (
                            <ChevronRight className={`dropdown-arrow ${activeMenu[level] === item.title ? 'open' : ''}`} />
                        )}
                    </Link>
                    {item.children && (
                        <UL className={`simple-list ${level !== 0 ? "nav-sub-childmenu submenu-content" : "sidebar-submenu "}`} style={{
                            display: `${(item.children
                                ? item.children.map((innerItem) => ActiveNavLinkUrl(innerItem.path)).includes(true) : ActiveNavLinkUrl(item.path)) || activeMenu[level] === item.title ? "block" : "none"
                                }`
                        }}
                        >
                            <SidebarSubMenu menu={item.children} activeMenu={activeMenu} setActiveMenu={setActiveMenu} level={level + 1} className="sidebar-submenu" />
                        </UL>
                    )}
                </LI >
            ))
            }
        </>
    )
}
